import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { NAV_ITEMS } from '@/components/layout/nav';
import { useBreadcrumbs } from '@/providers/breadcrumbs-context';
import { cn } from '@/lib/utils';

function defaultRoot(pathname: string) {
  if (pathname === '/') return { label: 'Home', to: '/' };
  const match = NAV_ITEMS.find(
    (item) => item.to !== '/' && pathname.startsWith(item.to),
  );
  if (match) return { label: match.label, to: match.to };
  return null;
}

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const crumbs = useBreadcrumbs();

  const trail = crumbs.length > 0 ? crumbs : (() => {
    const root = defaultRoot(pathname);
    return root ? [root] : [];
  })();

  if (trail.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="flex min-w-0 items-center">
      <ol className="text-muted-foreground flex min-w-0 items-center gap-1.5 text-sm">
        {trail.map((crumb, i) => {
          const isLast = i === trail.length - 1;
          return (
            <Fragment key={`${crumb.label}-${i}`}>
              {i > 0 ? <ChevronRight className="size-3.5 shrink-0 opacity-60" /> : null}
              <li className={cn('truncate', isLast && 'text-foreground font-medium')}>
                {crumb.to && !isLast ? (
                  <Link to={crumb.to} className="hover:text-foreground transition-colors">
                    {crumb.label}
                  </Link>
                ) : (
                  <span>{crumb.label}</span>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
